module.exports = __webpack_public_path__ + "img/homeS.feb77f07.png";